// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "./components/library/utils/CorePricingUtils.bs.js";
import * as CircularLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PricingDashboardComponent from "./components/components/PricingDashboardComponent.bs.js";
import * as PricingDashboardDataMachine from "../app/PricingDashboardDataMachine.bs.js";
import * as PricingDashboardStateMachine from "../app/PricingDashboardStateMachine.bs.js";
import * as PricingDashboardAssetsManager from "./assets/PricingDashboardAssetsManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

PricingDashboardAssetsManager.importCss(undefined);

function PricingDashboardContainer(Props) {
  var geo_region_id = Props.geo_region_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          return PricingDashboardStateMachine.reducer(action, state);
        }), /* FetchingRoles */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var updateSelectedVehicle = match$2[1];
  var selected_vehicle = match$2[0];
  var onVehicleChange = function (vehicle_id) {
    Curry._1(updateSelectedVehicle, (function (param) {
            return vehicle_id;
          }));
    return Curry._1(dispatch, /* RefetchCampaigns */0);
  };
  React.useEffect((function () {
          PricingDashboardDataMachine.fetchUserRole((function (roles) {
                  return Curry._1(dispatch, {
                              TAG: /* SetRole */0,
                              _0: {
                                TAG: /* OnLoaded */1,
                                _0: roles
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetRole */0,
                              _0: {
                                TAG: /* LoadErrorView */2,
                                _0: error
                              }
                            });
                }), country);
          
        }), []);
  React.useEffect((function () {
          if (typeof state !== "number") {
            switch (state.TAG | 0) {
              case /* FetchingGeoregions */0 :
                  PricingDashboardDataMachine.fetchGeoRegions((function (roles) {
                          return Curry._1(dispatch, {
                                      TAG: /* SetGeoRegions */1,
                                      _0: {
                                        TAG: /* OnLoaded */1,
                                        _0: roles
                                      }
                                    });
                        }), (function (error) {
                          return Curry._1(dispatch, {
                                      TAG: /* SetGeoRegions */1,
                                      _0: {
                                        TAG: /* LoadErrorView */2,
                                        _0: error
                                      }
                                    });
                        }), country);
                  break;
              case /* FetchingVehicles */1 :
                  PricingDashboardDataMachine.fetchVehicleTypes(geo_region_id, (function (vehicles) {
                          var vehicle_id = Belt_Option.mapWithDefault(List.nth_opt(vehicles, 0), undefined, (function (vehicle_type) {
                                  return vehicle_type.vehicle_id;
                                }));
                          Curry._1(updateSelectedVehicle, (function (param) {
                                  return vehicle_id;
                                }));
                          return Curry._1(dispatch, {
                                      TAG: /* SetVehicles */2,
                                      _0: {
                                        TAG: /* OnLoaded */1,
                                        _0: vehicles
                                      }
                                    });
                        }), (function (error) {
                          return Curry._1(dispatch, {
                                      TAG: /* SetVehicles */2,
                                      _0: {
                                        TAG: /* LoadErrorView */2,
                                        _0: error
                                      }
                                    });
                        }), country);
                  break;
              case /* FetchingCampaigns */2 :
                  if (selected_vehicle !== undefined) {
                    PricingDashboardDataMachine.fetchCampaigns(geo_region_id, selected_vehicle, (function (campaigns) {
                            return Curry._1(dispatch, {
                                        TAG: /* SetCampaigns */3,
                                        _0: {
                                          TAG: /* OnLoaded */1,
                                          _0: campaigns
                                        }
                                      });
                          }), (function (error) {
                            return Curry._1(dispatch, {
                                        TAG: /* SetCampaigns */3,
                                        _0: {
                                          TAG: /* LoadErrorView */2,
                                          _0: error
                                        }
                                      });
                          }), country);
                  }
                  break;
              default:
                
            }
          }
          
        }), [state]);
  var exit = 0;
  if (typeof state === "number") {
    if (state === /* NoRole */1) {
      return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: /* DefaultError */{
                    _0: {
                      title: {
                        TAG: /* Custom */0,
                        _0: "Access denied"
                      },
                      message: "You don't have access to view current page. Please get access."
                    }
                  }
                });
    } else {
      return React.createElement(CircularLoader$Catalyst.make, {});
    }
  }
  switch (state.TAG | 0) {
    case /* FetchingCampaigns */2 :
        if (selected_vehicle !== undefined) {
          return React.createElement(PricingDashboardComponent.make, {
                      geo_regions: state._1,
                      role: state._0,
                      selected_geo_region: geo_region_id,
                      vehicle_types: state._2,
                      selected_vehicle_type: selected_vehicle,
                      campaigns: {
                        TAG: /* Loading */0,
                        _0: undefined
                      },
                      changeVehicleSelection: onVehicleChange,
                      active_campaign: undefined,
                      refetch_core_pricings: (function (param) {
                          return Curry._1(dispatch, /* RefetchCampaigns */0);
                        })
                    });
        } else {
          return React.createElement(CircularLoader$Catalyst.make, {});
        }
    case /* ErrorFetchingRoles */3 :
    case /* ErrorFetchingGeoRegionOrVehicles */4 :
        exit = 1;
        break;
    case /* ErrorFetchingCampaigns */5 :
        if (selected_vehicle !== undefined) {
          return React.createElement(PricingDashboardComponent.make, {
                      geo_regions: state._1,
                      role: state._0,
                      selected_geo_region: geo_region_id,
                      vehicle_types: state._2,
                      selected_vehicle_type: selected_vehicle,
                      campaigns: {
                        TAG: /* Error */2,
                        _0: state._3
                      },
                      changeVehicleSelection: onVehicleChange,
                      active_campaign: undefined,
                      refetch_core_pricings: (function (param) {
                          return Curry._1(dispatch, /* RefetchCampaigns */0);
                        })
                    });
        }
        exit = 2;
        break;
    case /* Dashboard */6 :
        if (selected_vehicle !== undefined) {
          var campaigns = state._3;
          return React.createElement(PricingDashboardComponent.make, {
                      geo_regions: state._1,
                      role: state._0,
                      selected_geo_region: geo_region_id,
                      vehicle_types: state._2,
                      selected_vehicle_type: selected_vehicle,
                      campaigns: {
                        TAG: /* Live */1,
                        _0: campaigns
                      },
                      changeVehicleSelection: onVehicleChange,
                      active_campaign: List.nth_opt(CorePricingUtils.getActiveCampaign(campaigns), 0),
                      refetch_core_pricings: (function (param) {
                          return Curry._1(dispatch, /* RefetchCampaigns */0);
                        })
                    });
        }
        exit = 2;
        break;
    default:
      return React.createElement(CircularLoader$Catalyst.make, {});
  }
  switch (exit) {
    case 1 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: state._0
                  });
    case 2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: /* DefaultError */{
                      _0: {
                        title: {
                          TAG: /* Custom */0,
                          _0: "NoResultsFound"
                        },
                        message: "No vehicles found for current geo region"
                      }
                    }
                  });
    
  }
}

var make = PricingDashboardContainer;

export {
  make ,
  
}
/*  Not a pure module */
